export default "__VITE_ASSET__5qVEz6en__"